
<style lang="less" scoped></style>
<template>
  <div class="listOneOneNineDanger tableTransparent">
    <el-main>
      <el-row :gutter="32">
        <el-col :span="24">
          <el-table class="table_header_border" ref="oneoneNineRef" :data="tableData"
            style="width: 100%; background: #e1e3e9" v-loading="loading" :height="tableHeight"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            :header-cell-style="{ 'text-align': 'center', cellspacing: 5 }" :cell-style="{ padding: '0' }"
            :row-style="{ height: '32px' }" element-loading-background="rgba(0, 0, 0, 0.8)" @header-click="cell_click"
            :stripe="true">
            <el-table-column width="80" prop="date" label="状态" show-overflow-tooltip
              :filters="[{ text: '未处置', value: '3' }, { text: '处置中', value: '0' }, { text: '已处置', value: '1' }]"
              :filter-method="filterTag">
              <template slot-scope="scope">
                <span v-if="scope.row.closingacaseState == '0'" class="template-span0">处置中</span>
                <span v-if="scope.row.closingacaseState == '1'" class="template-span1">已处置</span>
                <span v-if="scope.row.closingacaseState == '2'" class="template-span2">误报</span>
                <span v-if="scope.row.closingacaseState == '3'" class="template-span3">未处置</span>
                <span v-if="scope.row.closingacaseState == '4'" class="template-span4">未总结</span>
              </template>
            </el-table-column>
            <el-table-column prop="disasterAddress" show-overflow-tooltip label="设备位置"></el-table-column>
            <el-table-column prop="number" label="警情编码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="closingacaseTime" label="持续时间" width="165" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alarmTime" label="报警时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reportTime" label="接警时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="departureTime" label="出警时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="arrivalTime" label="到达时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="backTime" label="收队时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="closingTime" label="报告时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="participateNumber" label="出动人数" show-overflow-tooltip width="80"></el-table-column>
            <el-table-column prop="equipmentNumber" label="出动装备" show-overflow-tooltip width="80"></el-table-column>
            <el-table-column prop="subNumber" label="报警总数" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="content" label="误报原因/总结内容" show-overflow-tooltip></el-table-column> -->
            <el-table-column label="火场文书">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="fireDocuments(scope.row)">
                  <img src="~@/assets/img/fireOperate.png" class="fireOperate" v-if="scope.row.closingacaseState != '3'  && scope.row.closingacaseState != '4' ">
                  <img src="~@/assets/img/fireOperate2.png" class="fireOperate" style="width: 100%;" v-if="scope.row.closingacaseState == '4'">
                  <img src="~@/assets/img/fireOperate1.png" class="fireOperate"  style="width: 100%;" v-if="scope.row.closingacaseState == '3'">
                </el-button> -->
                <el-button type="text" @click="fireDocuments(scope.row)" class="button_border"
                  v-if="scope.row.closingacaseState == '3'"><img src="~@/assets/img/fireOperate1.png" alt=""></el-button>
                <el-button type="text" @click="fireDocuments(scope.row)" class="button_border"
                  v-if="scope.row.closingacaseState == '4'"><img src="~@/assets/img/fireOperate2.png" alt=""></el-button>
                <el-button type="text" @click="fireDocuments(scope.row)" class="button_border special"
                  v-if="scope.row.closingacaseState != '3' && scope.row.closingacaseState != '4'"><img
                    class="img_special" src="~@/assets/img/fireOperate.png" alt=""></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagesCommon" style="position:relative">
            <span style="position:absolute;right:10px;top:10px">{{ this.$store.state.yearsTitle }}</span>
            <pages :total="total" @handleCurrentChangeSub="handleSearch">
            </pages>
          </div>
        </el-col>
      </el-row>
    </el-main>

    <el-dialog title="手报调度派单" :visible.sync="dialogVisible" v-if="fireBookDialog" show-close class="fireDoc" width="80%"
      append-to-body center @close="closeListModal()">
      <firePinkAlarm :dataFinish="dataFinish" :alarmId="alarmId"></firePinkAlarm>
    </el-dialog>

    <el-dialog title="手报报警" :visible.sync="dialogVisibleAction" show-close style="margin-top:-8vh;" class="fireDoc"
      append-to-body center>
      <firePink :alarmId="alarmId"></firePink>
    </el-dialog>

    <el-dialog title="查询条件" :visible.sync="dialogFormVisible" width="40%">
      <el-form>
        <el-form-item label="灾害地址" label-width="120px">
          <el-input v-model="queryData.address"></el-input>
        </el-form-item>
        <el-form-item label="处理状态" label-width="120px">
          <el-select placeholder="请选择处理状态" style="width: 100%;" v-model="queryData.statct">
            <el-option label="请选择" value=""></el-option>
            <el-option label="未处置" value="3"></el-option>
            <el-option label="处置中" value="0"></el-option>
            <el-option label="已处置" value="1"></el-option>
            <el-option label="误报" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报警时间" label-width="120px">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="queryData.dateTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="query">查 询</el-button>
      </div>
    </el-dialog>
    <el-dialog title="误报" :visible.sync="dialogWB.dialogWBVisible" show-close v-dialogDrag :close-on-click-modal="false"
      custom-class="q-dialog-wb" @close="handleClose()">
      <wbDialog v-if="wbDialog" :msgDataId="dialogWB.dialogWBId"></wbDialog>
    </el-dialog>
  </div>
</template>

<script>
import fireBook from "@/pages/fireBook/fireBook";
import firePinkAlarm from "@/pages/fireBook/firePinkAlarm";
import firePink from "@/pages/fireBook/firePink";
import wbDialog from "@/pages/baseCall/wbDialog";

export default {
  name: "listOneOneNineDangers",
  components: {
    firePinkAlarm,
    firePink,
    wbDialog
  },
  data() {
    return {
      queryData: {
        address: '',
        statct: '',
        dateTime: ''
      },
      dialogFormVisible: false,
      loading: false,
      total: 0,
      tableData: [],
      timelines: [],
      taskInfo: {},
      selectRow: {},
      dialogFullScreen: true,
      tableHeight: window.innerHeight - 172,
      handAlarmVisible: false,
      dialogVisible: false,
      dialogVisibleAction: false,
      alarmId: "",
      dataFinish: false,
      fireBookDialog: false,
      dialogWB: {
        dialogWBId: '',
        dialogWBVisible: false,
      },
      wbDialog: false,
    };
  },
  created() {
    let _this = this;
    _this.loading = true;
    _this.handleSearch(27, 1);
    _this.$root.eventHub.$on('dialogFlase', _this.dialogFlase);
  },
  methods: {
    handleClose() {
      let _this = this;
      _this.wbDialog = false;
    },
    cell_click(column) {
      let className = column.id;
      let selectClass = document.getElementsByClassName(className)[0];
      selectClass.style.border = "3px double #ccc";
      selectClass.style.paddingTop = "3px";
      setTimeout(function () {
        selectClass.style.border = "3px double #d6d5d5";
        selectClass.style.paddingTop = "0px";
        selectClass.style.borderRight = "0px";
      }, 80)
    },
    filterTag(value, row) {
      return row.closingacaseState === value;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    query() {
      let _this = this;
      _this.dialogFormVisible = false,
        _this.handleSearch(27, 1)
    },
    inquire() {
      this.dialogFormVisible = true
    },
    renderHeaderMethod(h, { column, $index }) {
      // h 是一个渲染函数       column 是一个对象表示当前列      $index 第几列
      return (<div >
        <span >状态</span><button onClick={this.inquire}> <i class='el-icon-search' ></i></button>
      </div>);
    },
    dialogFlase() {
      let _this = this;
      _this.handleSearch(27, 1);
      _this.dialogVisibleAction = false
    },
    fireDocuments(row) {
      let _this = this;
      _this.alarmId = row.id;
      if (row.closingacaseState == 0) {
        _this.fireBookDialog = true;
        _this.dataFinish = false;
        _this.dialogVisible = true;
      } else if (row.closingacaseState == 4) {
        _this.toSummarize(row.id);
      } else if (row.closingacaseState == 1) {
        _this.fireBookDialog = true;
        _this.dataFinish = true;
        _this.dialogVisible = true;
      } else if (row.closingacaseState == 2) {
        _this.dialogWB.dialogWBVisible = true;
        _this.wbDialog = true;
        _this.dialogWB.dialogWBId = row.id;
      } else {
        _this.didNotReceive(row.id);
      }
    },
    toSummarize(id) {
      let _this = this;
      _this.http.post("/webapi/writ/toSummarize", { id: id }, function (data) { });
    },
    didNotReceive(id) {
      let _this = this;
      _this.http.post("/webapi/writ/didNotReceive", { id: id }, function (data) { });
    },
    handleSearch(pageSize, page) {
      //查询列表信息
      let _this = this;
      let data = {
        pageNumber: page,
        pageSize: pageSize,
        singleState: 5,
        // disasterAddress:_this.queryData.address,
        // alarmTime:_this.queryData.dateTime,
        // closingacaseState:_this.queryData.statct
      };
      let success = function (resp) {
        if (resp.code === "0") {
          _this.total = parseInt(resp.data.total);
          _this.tableData = resp.data.records;
          _this.init();
        } else {
          _this.$message.error(resp.msg);
        }
        _this.loading = false;
      };
      // _this.http.get("/webapi/alarmManual/list", data, success);
      _this.http.get("/webapi/alarmSmoke/list", data, success);
    },
    closeListModal() {
      let _this = this;
      _this.dialogVisible = false;
      _this.fireBookDialog = false;
    },
    init() {
      let i = 0
      this.timer = setInterval(() => {
        i++
        this.tableData.forEach((item, idx) => {
          if (item.closingacaseState != '1' && item.closingacaseState != '2') {
            item.closingacaseTime = this.duractionTime(item);
          }
        })
      }, 1000)
    },
    duractionTime(item) {
      let _this = this;
      let timestamp = new Date().getTime();
      let oldTime = new Date(item.alarmTime).getTime(); //得到毫秒数
      let total = (timestamp - oldTime) / 1000;
      let day = parseInt(total / (24 * 60 * 60)); //计算整数天数
      let afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
      let hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
      let afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
      let min = parseInt(afterHour / 60); //计算整数分
      let afterMin = parseInt(total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60); //取得算出分后剩余的秒数
      let seconds = Math.round(afterMin / 1000);
      _this.timeAll =
        day + "天 " + hour + "小时 " + min + " 分钟" + afterMin + " 秒";
      return _this.timeAll;
    },
    notYet() {
      this.handAlarmVisible = true;
    },
  },
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/handNewspaperDangers/listHandNewspaperDangers.vue